import StimulusTomSelect from "stimulus-tom-select";

// Connects to data-controller="symbol-select"
export default class extends StimulusTomSelect {
  initTomSelect() {
    this.options = {
      maxItems: 1,
      render: {
        option: (data, escape) => this.renderOption(data, escape),
        item: (data, escape) => this.renderItem(data, escape)
      },
      ...this.optionsValue
    };

    super.initTomSelect();
  }

  renderOption(data, escape) {
    const label = escape(data.text || "");
    const iconUrl = data.$option?.dataset?.iconUrl;

    if (!iconUrl) {
      return `<div class="flex items-center gap-2"><span>${label}</span></div>`;
    }

    const safeIconUrl = escape(iconUrl);
    return `<div class="flex items-center gap-2"><img src="${safeIconUrl}" alt="" class="size-4 shrink-0" /><span>${label}</span></div>`;
  }

  renderItem(data, escape) {
    const label = escape(data.text || "");
    const iconUrl = data.$option?.dataset?.iconUrl;

    if (!iconUrl) {
      return `<div class="flex items-center gap-2"><span class="line-clamp-1">${label}</span></div>`;
    }

    const safeIconUrl = escape(iconUrl);
    return `<div class="flex items-center gap-2"><img src="${safeIconUrl}" alt="" class="size-4 shrink-0" /><span class="line-clamp-1">${label}</span></div>`;
  }
}
